document.addEventListener("DOMContentLoaded", function () {
    const openBtn = document.getElementById("open-lightbox");
    const lightbox = document.getElementById("lightbox-container");
    const closeBtn = document.getElementById("close-lightbox");
    const iframe = document.getElementById("lightbox-iframe");

    const bookCountry = openBtn.getAttribute("data-book-country") || "";
    const bookCountryEN = openBtn.getAttribute("data-book-country-en") || "";
    const bookProductID = openBtn.getAttribute("data-product-id") || "";
    const isPreview = openBtn.getAttribute("data-preview") || "";
    const language = openBtn.getAttribute("data-language") || "en"; // fallback to English

    // Function to prevent background scroll explicitly
    function preventBackgroundScroll() {
        document.body.style.overflow = 'hidden';
    }

    function allowBackgroundScroll() {
        document.body.style.overflow = '';
    }

    // Open Lightbox (explicitly prevent scrolling clearly)
    openBtn.addEventListener("click", function () {
        iframe.src = `https://nextjs-alpha-brown-65.vercel.app?book_country=${encodeURIComponent(bookCountry)}&book_country_en=${encodeURIComponent(bookCountryEN)}&product_id=${encodeURIComponent(bookProductID)}&preview=${isPreview}&lang=${encodeURIComponent(language)}`;
        lightbox.style.display = "block"; // change from flex to block (fullscreen)
        preventBackgroundScroll();
    });

    // Close Lightbox explicitly (re-enable scrolling)
    closeBtn.addEventListener("click", function () {
        lightbox.style.display = "none";
        iframe.src = "";
        allowBackgroundScroll();
    });

});